'use strict';

var cov_11v6m251aw = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\user\\usergroup\\usergroupCtrl.js',
      hash = '698c91b419bb340d711e496a1a42d9d336958b82',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\user\\usergroup\\usergroupCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 236,
          column: 3
        }
      },
      '1': {
        start: {
          line: 6,
          column: 15
        },
        end: {
          line: 6,
          column: 26
        }
      },
      '2': {
        start: {
          line: 7,
          column: 20
        },
        end: {
          line: 7,
          column: 26
        }
      },
      '3': {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 39
        }
      },
      '4': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 23
        }
      },
      '5': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 138,
          column: 4
        }
      },
      '6': {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 30
        }
      },
      '7': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 22,
          column: 9
        }
      },
      '8': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 37
        }
      },
      '9': {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 33
        }
      },
      '10': {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 31,
          column: 9
        }
      },
      '11': {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 41
        }
      },
      '12': {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 33
        }
      },
      '13': {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 44,
          column: 7
        }
      },
      '14': {
        start: {
          line: 38,
          column: 23
        },
        end: {
          line: 38,
          column: 102
        }
      },
      '15': {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 43,
          column: 11
        }
      },
      '16': {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 44
        }
      },
      '17': {
        start: {
          line: 47,
          column: 19
        },
        end: {
          line: 47,
          column: 45
        }
      },
      '18': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 66,
          column: 7
        }
      },
      '19': {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 51,
          column: 9
        }
      },
      '20': {
        start: {
          line: 50,
          column: 10
        },
        end: {
          line: 50,
          column: 19
        }
      },
      '21': {
        start: {
          line: 52,
          column: 18
        },
        end: {
          line: 52,
          column: 31
        }
      },
      '22': {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 59,
          column: 9
        }
      },
      '23': {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 58,
          column: 12
        }
      },
      '24': {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 62,
          column: 9
        }
      },
      '25': {
        start: {
          line: 61,
          column: 10
        },
        end: {
          line: 61,
          column: 58
        }
      },
      '26': {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 65,
          column: 9
        }
      },
      '27': {
        start: {
          line: 64,
          column: 10
        },
        end: {
          line: 64,
          column: 58
        }
      },
      '28': {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 27
        }
      },
      '29': {
        start: {
          line: 74,
          column: 24
        },
        end: {
          line: 74,
          column: 37
        }
      },
      '30': {
        start: {
          line: 75,
          column: 18
        },
        end: {
          line: 75,
          column: 93
        }
      },
      '31': {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 78,
          column: 7
        }
      },
      '32': {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 15
        }
      },
      '33': {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 52
        }
      },
      '34': {
        start: {
          line: 81,
          column: 19
        },
        end: {
          line: 81,
          column: 22
        }
      },
      '35': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 86,
          column: 7
        }
      },
      '36': {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 85,
          column: 9
        }
      },
      '37': {
        start: {
          line: 84,
          column: 10
        },
        end: {
          line: 84,
          column: 27
        }
      },
      '38': {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 48
        }
      },
      '39': {
        start: {
          line: 89,
          column: 19
        },
        end: {
          line: 89,
          column: 22
        }
      },
      '40': {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 102,
          column: 7
        }
      },
      '41': {
        start: {
          line: 91,
          column: 18
        },
        end: {
          line: 91,
          column: 22
        }
      },
      '42': {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 94,
          column: 9
        }
      },
      '43': {
        start: {
          line: 93,
          column: 10
        },
        end: {
          line: 93,
          column: 26
        }
      },
      '44': {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 97,
          column: 9
        }
      },
      '45': {
        start: {
          line: 96,
          column: 10
        },
        end: {
          line: 96,
          column: 26
        }
      },
      '46': {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 100,
          column: 9
        }
      },
      '47': {
        start: {
          line: 99,
          column: 10
        },
        end: {
          line: 99,
          column: 19
        }
      },
      '48': {
        start: {
          line: 101,
          column: 8
        },
        end: {
          line: 101,
          column: 23
        }
      },
      '49': {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 41
        }
      },
      '50': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 30
        }
      },
      '51': {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 108,
          column: 9
        }
      },
      '52': {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 34
        }
      },
      '53': {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 34
        }
      },
      '54': {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 136,
          column: 9
        }
      },
      '55': {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 124,
          column: 9
        }
      },
      '56': {
        start: {
          line: 123,
          column: 10
        },
        end: {
          line: 123,
          column: 17
        }
      },
      '57': {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 135,
          column: 11
        }
      },
      '58': {
        start: {
          line: 126,
          column: 10
        },
        end: {
          line: 133,
          column: 11
        }
      },
      '59': {
        start: {
          line: 127,
          column: 12
        },
        end: {
          line: 130,
          column: 15
        }
      },
      '60': {
        start: {
          line: 131,
          column: 12
        },
        end: {
          line: 131,
          column: 37
        }
      },
      '61': {
        start: {
          line: 132,
          column: 12
        },
        end: {
          line: 132,
          column: 19
        }
      },
      '62': {
        start: {
          line: 134,
          column: 10
        },
        end: {
          line: 134,
          column: 36
        }
      },
      '63': {
        start: {
          line: 140,
          column: 2
        },
        end: {
          line: 180,
          column: 4
        }
      },
      '64': {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 151,
          column: 7
        }
      },
      '65': {
        start: {
          line: 147,
          column: 8
        },
        end: {
          line: 150,
          column: 11
        }
      },
      '66': {
        start: {
          line: 148,
          column: 10
        },
        end: {
          line: 148,
          column: 35
        }
      },
      '67': {
        start: {
          line: 149,
          column: 10
        },
        end: {
          line: 149,
          column: 40
        }
      },
      '68': {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 31
        }
      },
      '69': {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 156,
          column: 25
        }
      },
      '70': {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 164,
          column: 7
        }
      },
      '71': {
        start: {
          line: 158,
          column: 23
        },
        end: {
          line: 158,
          column: 84
        }
      },
      '72': {
        start: {
          line: 159,
          column: 8
        },
        end: {
          line: 163,
          column: 11
        }
      },
      '73': {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 165,
          column: 27
        }
      },
      '74': {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 27
        }
      },
      '75': {
        start: {
          line: 171,
          column: 19
        },
        end: {
          line: 171,
          column: 22
        }
      },
      '76': {
        start: {
          line: 172,
          column: 6
        },
        end: {
          line: 176,
          column: 7
        }
      },
      '77': {
        start: {
          line: 173,
          column: 8
        },
        end: {
          line: 175,
          column: 9
        }
      },
      '78': {
        start: {
          line: 174,
          column: 10
        },
        end: {
          line: 174,
          column: 27
        }
      },
      '79': {
        start: {
          line: 177,
          column: 6
        },
        end: {
          line: 177,
          column: 56
        }
      },
      '80': {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 178,
          column: 109
        }
      },
      '81': {
        start: {
          line: 182,
          column: 2
        },
        end: {
          line: 232,
          column: 4
        }
      },
      '82': {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 31
        }
      },
      '83': {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 29
        }
      },
      '84': {
        start: {
          line: 188,
          column: 19
        },
        end: {
          line: 188,
          column: 36
        }
      },
      '85': {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 207,
          column: 7
        }
      },
      '86': {
        start: {
          line: 190,
          column: 8
        },
        end: {
          line: 192,
          column: 9
        }
      },
      '87': {
        start: {
          line: 191,
          column: 10
        },
        end: {
          line: 191,
          column: 19
        }
      },
      '88': {
        start: {
          line: 193,
          column: 18
        },
        end: {
          line: 193,
          column: 31
        }
      },
      '89': {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 200,
          column: 9
        }
      },
      '90': {
        start: {
          line: 195,
          column: 10
        },
        end: {
          line: 199,
          column: 12
        }
      },
      '91': {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 203,
          column: 9
        }
      },
      '92': {
        start: {
          line: 202,
          column: 10
        },
        end: {
          line: 202,
          column: 43
        }
      },
      '93': {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 206,
          column: 9
        }
      },
      '94': {
        start: {
          line: 205,
          column: 10
        },
        end: {
          line: 205,
          column: 43
        }
      },
      '95': {
        start: {
          line: 209,
          column: 6
        },
        end: {
          line: 209,
          column: 27
        }
      },
      '96': {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 212,
          column: 27
        }
      },
      '97': {
        start: {
          line: 215,
          column: 19
        },
        end: {
          line: 215,
          column: 22
        }
      },
      '98': {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 228,
          column: 7
        }
      },
      '99': {
        start: {
          line: 217,
          column: 18
        },
        end: {
          line: 217,
          column: 22
        }
      },
      '100': {
        start: {
          line: 218,
          column: 8
        },
        end: {
          line: 220,
          column: 9
        }
      },
      '101': {
        start: {
          line: 219,
          column: 10
        },
        end: {
          line: 219,
          column: 26
        }
      },
      '102': {
        start: {
          line: 221,
          column: 8
        },
        end: {
          line: 223,
          column: 9
        }
      },
      '103': {
        start: {
          line: 222,
          column: 10
        },
        end: {
          line: 222,
          column: 26
        }
      },
      '104': {
        start: {
          line: 224,
          column: 8
        },
        end: {
          line: 226,
          column: 9
        }
      },
      '105': {
        start: {
          line: 225,
          column: 10
        },
        end: {
          line: 225,
          column: 19
        }
      },
      '106': {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 227,
          column: 23
        }
      },
      '107': {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 229,
          column: 49
        }
      },
      '108': {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 230,
          column: 106
        }
      },
      '109': {
        start: {
          line: 234,
          column: 2
        },
        end: {
          line: 234,
          column: 28
        }
      },
      '110': {
        start: {
          line: 235,
          column: 2
        },
        end: {
          line: 235,
          column: 24
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 5,
            column: 50
          },
          end: {
            line: 5,
            column: 51
          }
        },
        loc: {
          start: {
            line: 5,
            column: 170
          },
          end: {
            line: 236,
            column: 1
          }
        },
        line: 5
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 19,
            column: 46
          },
          end: {
            line: 19,
            column: 47
          }
        },
        loc: {
          start: {
            line: 19,
            column: 54
          },
          end: {
            line: 22,
            column: 7
          }
        },
        line: 19
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 105,
            column: 89
          },
          end: {
            line: 105,
            column: 90
          }
        },
        loc: {
          start: {
            line: 105,
            column: 97
          },
          end: {
            line: 108,
            column: 7
          }
        },
        line: 105
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 121,
            column: 9
          },
          end: {
            line: 121,
            column: 10
          }
        },
        loc: {
          start: {
            line: 121,
            column: 22
          },
          end: {
            line: 136,
            column: 7
          }
        },
        line: 121
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 125,
            column: 84
          },
          end: {
            line: 125,
            column: 85
          }
        },
        loc: {
          start: {
            line: 125,
            column: 92
          },
          end: {
            line: 135,
            column: 9
          }
        },
        line: 125
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 147,
            column: 58
          },
          end: {
            line: 147,
            column: 59
          }
        },
        loc: {
          start: {
            line: 147,
            column: 66
          },
          end: {
            line: 150,
            column: 9
          }
        },
        line: 147
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 178,
            column: 97
          },
          end: {
            line: 178,
            column: 98
          }
        },
        loc: {
          start: {
            line: 178,
            column: 105
          },
          end: {
            line: 178,
            column: 107
          }
        },
        line: 178
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 230,
            column: 94
          },
          end: {
            line: 230,
            column: 95
          }
        },
        loc: {
          start: {
            line: 230,
            column: 102
          },
          end: {
            line: 230,
            column: 104
          }
        },
        line: 230
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }, {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }],
        line: 49
      },
      '1': {
        loc: {
          start: {
            line: 49,
            column: 12
          },
          end: {
            line: 49,
            column: 26
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 49,
            column: 12
          },
          end: {
            line: 49,
            column: 19
          }
        }, {
          start: {
            line: 49,
            column: 23
          },
          end: {
            line: 49,
            column: 26
          }
        }],
        line: 49
      },
      '2': {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }, {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }],
        line: 53
      },
      '3': {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        }],
        line: 60
      },
      '4': {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        }, {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        }],
        line: 63
      },
      '5': {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 78,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 78,
            column: 7
          }
        }, {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 78,
            column: 7
          }
        }],
        line: 76
      },
      '6': {
        loc: {
          start: {
            line: 76,
            column: 10
          },
          end: {
            line: 76,
            column: 34
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 76,
            column: 10
          },
          end: {
            line: 76,
            column: 13
          }
        }, {
          start: {
            line: 76,
            column: 17
          },
          end: {
            line: 76,
            column: 34
          }
        }],
        line: 76
      },
      '7': {
        loc: {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        }, {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        }],
        line: 83
      },
      '8': {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        }, {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 94,
            column: 9
          }
        }],
        line: 92
      },
      '9': {
        loc: {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        }, {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        }],
        line: 95
      },
      '10': {
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        }, {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        }],
        line: 98
      },
      '11': {
        loc: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 124,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 124,
            column: 9
          }
        }, {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 124,
            column: 9
          }
        }],
        line: 122
      },
      '12': {
        loc: {
          start: {
            line: 126,
            column: 10
          },
          end: {
            line: 133,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 126,
            column: 10
          },
          end: {
            line: 133,
            column: 11
          }
        }, {
          start: {
            line: 126,
            column: 10
          },
          end: {
            line: 133,
            column: 11
          }
        }],
        line: 126
      },
      '13': {
        loc: {
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        }, {
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        }],
        line: 146
      },
      '14': {
        loc: {
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 175,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 175,
            column: 9
          }
        }, {
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 175,
            column: 9
          }
        }],
        line: 173
      },
      '15': {
        loc: {
          start: {
            line: 190,
            column: 8
          },
          end: {
            line: 192,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 190,
            column: 8
          },
          end: {
            line: 192,
            column: 9
          }
        }, {
          start: {
            line: 190,
            column: 8
          },
          end: {
            line: 192,
            column: 9
          }
        }],
        line: 190
      },
      '16': {
        loc: {
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 190,
            column: 26
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 190,
            column: 19
          }
        }, {
          start: {
            line: 190,
            column: 23
          },
          end: {
            line: 190,
            column: 26
          }
        }],
        line: 190
      },
      '17': {
        loc: {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 200,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 200,
            column: 9
          }
        }, {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 200,
            column: 9
          }
        }],
        line: 194
      },
      '18': {
        loc: {
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 203,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 203,
            column: 9
          }
        }, {
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 203,
            column: 9
          }
        }],
        line: 201
      },
      '19': {
        loc: {
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 206,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 206,
            column: 9
          }
        }, {
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 206,
            column: 9
          }
        }],
        line: 204
      },
      '20': {
        loc: {
          start: {
            line: 218,
            column: 8
          },
          end: {
            line: 220,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 218,
            column: 8
          },
          end: {
            line: 220,
            column: 9
          }
        }, {
          start: {
            line: 218,
            column: 8
          },
          end: {
            line: 220,
            column: 9
          }
        }],
        line: 218
      },
      '21': {
        loc: {
          start: {
            line: 221,
            column: 8
          },
          end: {
            line: 223,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 221,
            column: 8
          },
          end: {
            line: 223,
            column: 9
          }
        }, {
          start: {
            line: 221,
            column: 8
          },
          end: {
            line: 223,
            column: 9
          }
        }],
        line: 221
      },
      '22': {
        loc: {
          start: {
            line: 224,
            column: 8
          },
          end: {
            line: 226,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 224,
            column: 8
          },
          end: {
            line: 226,
            column: 9
          }
        }, {
          start: {
            line: 224,
            column: 8
          },
          end: {
            line: 226,
            column: 9
          }
        }],
        line: 224
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_11v6m251aw.s[0]++;
/**
 * Created by BKSB on 18/04/2017.
 */

angular.module('app').controller('userGroupCtrl', function ($scope, SweetAlert, $translate, $deltaLocation, $CRUDService, $otherHttpService, $deltahttp, $filter, FileUploader) {
  cov_11v6m251aw.f[0]++;

  var PATH = (cov_11v6m251aw.s[1]++, 'UserGroup');
  var PATH_USER = (cov_11v6m251aw.s[2]++, 'User');
  cov_11v6m251aw.s[3]++;
  $deltaLocation.addController($scope);
  cov_11v6m251aw.s[4]++;
  $scope.pageIndex = 1;
  cov_11v6m251aw.s[5]++;
  $scope.userGroup = {
    selected: null,
    user: {
      data: [],
      isloading: false
    },
    data: [],
    getAll: function getAll() {
      cov_11v6m251aw.s[6]++;

      $scope.isloading = true;
      cov_11v6m251aw.s[7]++;
      $CRUDService.getAll(PATH, { get: 'all' }, function (data) {
        cov_11v6m251aw.f[1]++;
        cov_11v6m251aw.s[8]++;

        $scope.userGroup.data = data;
        cov_11v6m251aw.s[9]++;
        $scope.isloading = false;
      });
    },
    newItem: function newItem() {
      cov_11v6m251aw.s[10]++;

      this.edit({
        CODE: '',
        LABEL: '',
        USERLIST: '0;',
        id: 0,
        l: '0;'
      });
    },
    edit: function edit(item) {
      cov_11v6m251aw.s[11]++;

      this.selected = angular.copy(item);
      //* ****************************** Utilisateur ********************************/
      cov_11v6m251aw.s[12]++;
      $scope.users.listUser = [];
      cov_11v6m251aw.s[13]++;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = $scope.users.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          var check = (cov_11v6m251aw.s[14]++, this.selected.USERLIST.replace(';' + el.id + ';', '') != this.selected.USERLIST);
          cov_11v6m251aw.s[15]++;
          $scope.users.listUser.push({
            name: el.NOMUSER + ' ' + el.PRENOMUSER,
            checked: check,
            id: el.id
          });
        }
        //* ************************** Localités *************************************/
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      cov_11v6m251aw.s[16]++;
      $scope.userLocation.listSelected = {};
      var data = (cov_11v6m251aw.s[17]++, this.selected.l.split(';'));
      cov_11v6m251aw.s[18]++;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _el = _step2.value;
          cov_11v6m251aw.s[19]++;

          if ((cov_11v6m251aw.b[1][0]++, _el == 0) || (cov_11v6m251aw.b[1][1]++, !_el)) {
            cov_11v6m251aw.b[0][0]++;
            cov_11v6m251aw.s[20]++;

            continue;
          } else {
            cov_11v6m251aw.b[0][1]++;
          }
          var t = (cov_11v6m251aw.s[21]++, _el.split('-'));
          cov_11v6m251aw.s[22]++;
          if (!$scope.userLocation.listSelected[t[0]]) {
            cov_11v6m251aw.b[2][0]++;
            cov_11v6m251aw.s[23]++;

            $scope.userLocation.listSelected[String(t[0])] = {
              s: false,
              a: false,
              id: t[0]
            };
          } else {
            cov_11v6m251aw.b[2][1]++;
          }
          cov_11v6m251aw.s[24]++;
          if (t[1] == 1) {
            cov_11v6m251aw.b[3][0]++;
            cov_11v6m251aw.s[25]++;

            $scope.userLocation.listSelected[t[0]].s = true;
          } else {
            cov_11v6m251aw.b[3][1]++;
          }
          cov_11v6m251aw.s[26]++;
          if (t[1] == 2) {
            cov_11v6m251aw.b[4][0]++;
            cov_11v6m251aw.s[27]++;

            $scope.userLocation.listSelected[t[0]].a = true;
          } else {
            cov_11v6m251aw.b[4][1]++;
          }
        }

        //* *************************************************************************/
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    cancel: function cancel() {
      cov_11v6m251aw.s[28]++;

      this.selected = null;
    },
    validate: function validate() {
      var usergroup = (cov_11v6m251aw.s[29]++, this.selected);
      var dbl = (cov_11v6m251aw.s[30]++, $filter('filter')($scope.userGroup.data, { CODE: usergroup.CODE }, true)[0]);
      cov_11v6m251aw.s[31]++;
      if ((cov_11v6m251aw.b[6][0]++, dbl) && (cov_11v6m251aw.b[6][1]++, usergroup.id == 0)) {
        cov_11v6m251aw.b[5][0]++;
        cov_11v6m251aw.s[32]++;

        return;
      } else {
        cov_11v6m251aw.b[5][1]++;
      }
      cov_11v6m251aw.s[33]++;
      usergroup.CODE = usergroup.CODE.toUpperCase();
      //* ************************************* User *****************************************/
      var list = (cov_11v6m251aw.s[34]++, [0]);
      cov_11v6m251aw.s[35]++;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = $scope.users.listUser[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _el2 = _step3.value;
          cov_11v6m251aw.s[36]++;

          if (_el2.checked) {
            cov_11v6m251aw.b[7][0]++;
            cov_11v6m251aw.s[37]++;

            list.push(_el2.id);
          } else {
            cov_11v6m251aw.b[7][1]++;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      cov_11v6m251aw.s[38]++;
      usergroup.USERLIST = list.join(';') + ';';
      //* ********************************* Localité ****************************************/
      var data = (cov_11v6m251aw.s[39]++, [0]);
      cov_11v6m251aw.s[40]++;
      for (var el in $scope.userLocation.listSelected) {
        var val = (cov_11v6m251aw.s[41]++, null);
        cov_11v6m251aw.s[42]++;
        if ($scope.userLocation.listSelected[el].s) {
          cov_11v6m251aw.b[8][0]++;
          cov_11v6m251aw.s[43]++;

          val = el + '-1';
        } else {
          cov_11v6m251aw.b[8][1]++;
        }
        cov_11v6m251aw.s[44]++;
        if ($scope.userLocation.listSelected[el].a) {
          cov_11v6m251aw.b[9][0]++;
          cov_11v6m251aw.s[45]++;

          val = el + '-2';
        } else {
          cov_11v6m251aw.b[9][1]++;
        }
        cov_11v6m251aw.s[46]++;
        if (!val) {
          cov_11v6m251aw.b[10][0]++;
          cov_11v6m251aw.s[47]++;

          continue;
        } else {
          cov_11v6m251aw.b[10][1]++;
        }
        cov_11v6m251aw.s[48]++;
        data.push(val);
      }
      cov_11v6m251aw.s[49]++;
      usergroup.l = data.join(';') + ';';
      cov_11v6m251aw.s[50]++;
      $scope.isloading = true;
      cov_11v6m251aw.s[51]++;
      $CRUDService.save(PATH, { action: 'miseAJour', valeur: $filter('json')(usergroup) }, function (data) {
        cov_11v6m251aw.f[2]++;
        cov_11v6m251aw.s[52]++;

        $scope.userGroup.cancel();
        cov_11v6m251aw.s[53]++;
        $scope.userGroup.getAll();
      });
    },
    deleteItem: function deleteItem(item) {
      cov_11v6m251aw.s[54]++;

      SweetAlert.swal({
        title: $translate.instant('COMMON.CONFIRM'),
        text: $translate.instant('GR_U.CONFIRM_DELETE'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
        confirmButtonText: $translate.instant('COMMON.YES'),
        cancelButtonText: $translate.instant('COMMON.NO'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_11v6m251aw.f[3]++;
        cov_11v6m251aw.s[55]++;

        if (!isconfirm) {
          cov_11v6m251aw.b[11][0]++;
          cov_11v6m251aw.s[56]++;

          return;
        } else {
          cov_11v6m251aw.b[11][1]++;
        }
        cov_11v6m251aw.s[57]++;
        $CRUDService.delet(PATH, { action: 'delete', valeur: $filter('json')(item) }, function (data) {
          cov_11v6m251aw.f[4]++;
          cov_11v6m251aw.s[58]++;

          if (data < 0) {
            cov_11v6m251aw.b[12][0]++;
            cov_11v6m251aw.s[59]++;

            SweetAlert.swal({
              title: $translate.instant('COMMON.ERROR_DELETE'),
              text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
            });
            cov_11v6m251aw.s[60]++;
            $scope.isloading = false;
            cov_11v6m251aw.s[61]++;
            return;
          } else {
            cov_11v6m251aw.b[12][1]++;
          }
          cov_11v6m251aw.s[62]++;
          $scope.userGroup.getAll();
        });
      });
    }
  };

  cov_11v6m251aw.s[63]++;
  $scope.users = {
    data: [],
    isloading: false,
    listUser: [],
    selectedItem: null,
    getAll: function getAll() {
      cov_11v6m251aw.s[64]++;

      if (!$scope.userGroup.user.isloading) {
        cov_11v6m251aw.b[13][0]++;
        cov_11v6m251aw.s[65]++;

        $CRUDService.getAll(PATH_USER, { get: 'NonAdmin' }, function (data) {
          cov_11v6m251aw.f[5]++;
          cov_11v6m251aw.s[66]++;

          $scope.users.data = data;
          cov_11v6m251aw.s[67]++;
          $scope.users.isloading = true;
        });
      } else {
        cov_11v6m251aw.b[13][1]++;
      }
    },
    openUserList: function openUserList(item) {
      cov_11v6m251aw.s[68]++;

      this.selectedItem = item;
      cov_11v6m251aw.s[69]++;
      this.listUser = [];
      cov_11v6m251aw.s[70]++;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = $scope.users.data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var el = _step4.value;

          var check = (cov_11v6m251aw.s[71]++, item.USERLIST.replace(';' + el.id + ';', '') != item.USERLIST);
          cov_11v6m251aw.s[72]++;
          this.listUser.push({
            name: el.NOMUSER + ' ' + el.PRENOMUSER,
            checked: check,
            id: el.id
          });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      cov_11v6m251aw.s[73]++;
      $scope.pageIndex = 2;
    },
    cancel: function cancel() {
      cov_11v6m251aw.s[74]++;

      $scope.pageIndex = 1;
    },
    validate: function validate() {
      var list = (cov_11v6m251aw.s[75]++, [0]);
      cov_11v6m251aw.s[76]++;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.listUser[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var el = _step5.value;
          cov_11v6m251aw.s[77]++;

          if (el.checked) {
            cov_11v6m251aw.b[14][0]++;
            cov_11v6m251aw.s[78]++;

            list.push(el.id);
          } else {
            cov_11v6m251aw.b[14][1]++;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      cov_11v6m251aw.s[79]++;
      this.selectedItem.USERLIST = list.join(';') + ';';
      cov_11v6m251aw.s[80]++;
      $CRUDService.save(PATH, { action: 'miseAList', valeur: $filter('json')(this.selectedItem) }, function (data) {
        cov_11v6m251aw.f[6]++;
      });
    }
  };

  cov_11v6m251aw.s[81]++;
  $scope.userLocation = {
    selectedItem: null,
    listSelected: {},
    open: function open(item) {
      cov_11v6m251aw.s[82]++;

      this.selectedItem = item;
      cov_11v6m251aw.s[83]++;
      this.listSelected = {};
      var data = (cov_11v6m251aw.s[84]++, item.l.split(';'));
      cov_11v6m251aw.s[85]++;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = data[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var el = _step6.value;
          cov_11v6m251aw.s[86]++;

          if ((cov_11v6m251aw.b[16][0]++, el == 0) || (cov_11v6m251aw.b[16][1]++, !el)) {
            cov_11v6m251aw.b[15][0]++;
            cov_11v6m251aw.s[87]++;

            continue;
          } else {
            cov_11v6m251aw.b[15][1]++;
          }
          var t = (cov_11v6m251aw.s[88]++, el.split('-'));
          cov_11v6m251aw.s[89]++;
          if (!this.listSelected[t[0]]) {
            cov_11v6m251aw.b[17][0]++;
            cov_11v6m251aw.s[90]++;

            this.listSelected[String(t[0])] = {
              s: false,
              a: false,
              id: t[0]
            };
          } else {
            cov_11v6m251aw.b[17][1]++;
          }
          cov_11v6m251aw.s[91]++;
          if (t[1] == 1) {
            cov_11v6m251aw.b[18][0]++;
            cov_11v6m251aw.s[92]++;

            this.listSelected[t[0]].s = true;
          } else {
            cov_11v6m251aw.b[18][1]++;
          }
          cov_11v6m251aw.s[93]++;
          if (t[1] == 2) {
            cov_11v6m251aw.b[19][0]++;
            cov_11v6m251aw.s[94]++;

            this.listSelected[t[0]].a = true;
          } else {
            cov_11v6m251aw.b[19][1]++;
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      cov_11v6m251aw.s[95]++;
      $scope.pageIndex = 3;
    },
    cancel: function cancel() {
      cov_11v6m251aw.s[96]++;

      $scope.pageIndex = 1;
    },
    validate: function validate() {
      var data = (cov_11v6m251aw.s[97]++, [0]);
      cov_11v6m251aw.s[98]++;
      for (var el in this.listSelected) {
        var val = (cov_11v6m251aw.s[99]++, null);
        cov_11v6m251aw.s[100]++;
        if (this.listSelected[el].s) {
          cov_11v6m251aw.b[20][0]++;
          cov_11v6m251aw.s[101]++;

          val = el + '-1';
        } else {
          cov_11v6m251aw.b[20][1]++;
        }
        cov_11v6m251aw.s[102]++;
        if (this.listSelected[el].a) {
          cov_11v6m251aw.b[21][0]++;
          cov_11v6m251aw.s[103]++;

          val = el + '-2';
        } else {
          cov_11v6m251aw.b[21][1]++;
        }
        cov_11v6m251aw.s[104]++;
        if (!val) {
          cov_11v6m251aw.b[22][0]++;
          cov_11v6m251aw.s[105]++;

          continue;
        } else {
          cov_11v6m251aw.b[22][1]++;
        }
        cov_11v6m251aw.s[106]++;
        data.push(val);
      }
      cov_11v6m251aw.s[107]++;
      this.selectedItem.l = data.join(';') + ';';
      cov_11v6m251aw.s[108]++;
      $CRUDService.save(PATH, { action: 'miseAd', valeur: $filter('json')(this.selectedItem) }, function (data) {
        cov_11v6m251aw.f[7]++;
      });
    }
  };

  cov_11v6m251aw.s[109]++;
  $scope.userGroup.getAll();
  cov_11v6m251aw.s[110]++;
  $scope.users.getAll();
});